import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3bf69178&scoped=true&"
import script from "./footer.component.ts?vue&type=script&lang=ts&"
export * from "./footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=3bf69178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf69178",
  null
  
)

export default component.exports